import request from "@/CommonDP/utils/request";
export default {
  getPrjData(params) {
    return request.post("/project/getProjects", params);
  },
  // 删除
  deleteCertainEval(prjId) {
    return request.get(`/project/delete?prjId=${prjId}`);
  },
  categorylist() {
    return request.get("/CertainEval/categorylist");
  },
  levellist() {
    return request.get("/CertainEval/levellist");
  },
  planlist() {
    return request.get("/CertainEval/planlist");
  },
  designlist() {
    return request.get("/CertainEval/designlist");
  },
  insertCertainEval(params) {
    return request.post("/project/create", params);
  },
  viewList(prjID) {
    return request.get(
      `/project/getProjectDetails?projectId=${prjID}`
    );
  },
  updateCertainEval(params) {
    return request.post("/project/update", params);
  },
  dicList(dicCode) {
    return request.get(
      `/dic/content/list?dicCode=${dicCode}`
    );
  },
  // 编辑查看是否有该项目的权限
  getByProjectIdForEdit(id) {
    return request.get(
      `/project/getByProjectIdForEdit?projectId=${id}`
    );
  },
  // 导出
  exportExcel(params) {
    return request({
      responseType: "blob",
      url: "/project/exportExcel",
      method: "post",
      data: params
    });
  },
  changeEnabled(params) {
    return request.get("/project/enabled", { params });
  }
};
